import { IRoute } from '../interface/interface';
import { Companies } from '../pages/SysAdminPages/pages/Company/Companies';
import { Company } from '../pages/SysAdminPages/pages/Company/Company';
import { VersionsForCompany } from '../pages/SysAdminPages/pages/Company/VersionsForCompany';
import { EaterGroup } from '../pages/SysAdminPages/pages/EaterGroup/EaterGroup';
import { EaterGroups } from '../pages/SysAdminPages/pages/EaterGroup/EaterGroups';
import { VersionsForEaterGroup } from '../pages/SysAdminPages/pages/EaterGroup/VersionsForEaterGroup';
import { Office } from '../pages/SysAdminPages/pages/Office/Office';
import { Offices } from '../pages/SysAdminPages/pages/Office/Offices';
import { VersionsForOffice } from '../pages/SysAdminPages/pages/Office/VersionsForOffice';
import { User } from '../pages/SysAdminPages/pages/User/User';
import { Users } from '../pages/SysAdminPages/pages/User/Users';
import { VersionsForUser } from '../pages/SysAdminPages/pages/User/VersionsForUser';

function entityRoutes(section: string, idParam: string, label: string, list: any, detail: any, versions: any): IRoute[] {
    const base = `/sysadmin/${section}`;
    return [
        { path: base, name: `Sysadmin ${label} list`, component: list, exact: true, roleRequired: 'system_admin_users' },
        { path: `${base}/:${idParam}`, name: `Sysadmin ${label}`, component: detail, exact: true, roleRequired: 'system_admin_users' },
        { path: `${base}/:${idParam}/versions`, name: `Sysadmin ${label} history`, component: versions, exact: true, roleRequired: 'system_admin_users' },
        // A historic version is shown read-only in the regular detail page
        { path: `${base}/:${idParam}/versions/:version`, name: `Sysadmin ${label} version`, component: detail, exact: true, roleRequired: 'system_admin_users' },
    ];
}

const sysadminRoutes: IRoute[] = [
    ...entityRoutes('companies', 'companyId', 'company', Companies, Company, VersionsForCompany),
    ...entityRoutes('offices', 'officeId', 'office', Offices, Office, VersionsForOffice),
    ...entityRoutes('eaterGroups', 'eaterGroupId', 'eater group', EaterGroups, EaterGroup, VersionsForEaterGroup),
    ...entityRoutes('users', 'userId', 'user', Users, User, VersionsForUser),
];

export default sysadminRoutes;
